module.exports = __webpack_public_path__ + "static/img/logo_cnst.25a2498.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_cnst.png
// module id = Ewfh
// module chunks = 15